<template>
  <div id="app">
    <div v-if="showModalAddBillImages">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Thay đổi ảnh hóa đơn/ Ảnh selfie
                  </h5>
                  <button
                    type="button"
                    @click="closeAddPhuLuc()"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <div class="form-group row img-list mr-0 ml-0">
                    <ul v-viewer>
                      <li v-for="(item, index) in imageData" :key="index">
                        <a href="#popup-slider" data-toggle="modal">
                          <img :src="item.dataURL" />
                          <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                        </a>
                      </li>
                      <li>
                        <div class="add-img">
                          <span class="bx bx-plus text-center"></span>
                          <input @input="onSelectFile" ref="fileInput" type="file" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" @click="closeAddPhuLuc()" class="btn btn-light">
                    Đóng
                  </button>
                  <button
                    @click="submitAdd()"
                    type="button"
                    class="btn btn-primary"
                    :disabled="imageData.length === 0 || changeImage === false"
                  >
                    Cập nhật
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div id="app">
      <div v-if="showModalErr">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="showModalErr = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ messErr }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="showModalErr = false"
                      data-dismiss="modal"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="showLoading">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Thông báo</h5>
                </div>
                <div class="modal-body text-center">
                  <div class="box-loading d-flex justify-content-center">
                    <div class="loading f20 py-2">
                      <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
                    </div>
                  </div>
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import { ContractService } from '@/services/contract.service'

  export default {
    props: ['showModalAddBillImages', 'dataImagesContract', 'dataContract', 'generalImages'],

    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        formData2: new FormData(),
        arrayFormData: [],
        arrayImgInsertSuccess: [],
        imageData: [],
        showModalErr: false,
        messErr: '',
        changeImage: false,
        showLoading: false,
        generalImagesUpload: [],
      }
    },

    updated() {
      this.imageData = this.dataImagesContract
    },

    methods: {
      async onSelectFile() {
        const input = this.$refs.fileInput
        const files = input.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFomat = fomatUpload.includes(input.files[0].type)
        if (!checkFomat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        var FileSize = input.files[0].size / 1024 / 1024 // in MB

        if (FileSize > 2) {
          alert('Size ảnh quá lớn')
          return
        }
        this.formData2 = new FormData()
        this.formData2.append('files', files[0])
        this.formData2.append('folderName', 'Bill') // NextCrm
        this.arrayFormData.push(this.formData2)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push({ dataURL: e.target.result })
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        this.changeImage = true
      },

      async closeAddPhuLuc() {
        this.imageData = []
        this.arrayImgInsertSuccess = []
        this.arrayFormData = []
        this.changeImage = false
        this.$emit('close')
      },

      async submitAdd() {
        try {
          this.showLoading = true
          this.messErr = 'Đang cập nhật ảnh, vui lòng chờ !'
          this.transformStoreImage()
          if (this.arrayFormData.length === 0) {
            await this.updateImages()
          } else {
            await this.uploadImg()
          }
          await this.$emit('submitAddBillImages', { dataImages: this.imageData })
          this.showLoading = false
          this.closeAddPhuLuc()
          // this.$emit('close')
        } catch (error) {
          console.log(error)
        }
      },

      removeImg(index) {
        this.transformImage()
        const accessKeyCheck = this.imageData[index].accessKey
        if (accessKeyCheck) {
          this.generalImages.map((e, i) => {
            if (accessKeyCheck === e.accessKey) {
              this.generalImages.splice(i, 1)
            }
          })
          if (this.arrayFormData.length === 0) {
            this.generalImagesUpload.map((e, i) => {
              if (accessKeyCheck === e.accessKey) {
                this.generalImagesUpload.splice(i, 1)
              }
            })
          }
        } else {
          const indexImg = index - this.dataImagesContract.length - 1
          this.arrayFormData.splice(indexImg, 1)
        }
        this.imageData.splice(index, 1)
        if (this.dataContract.imageStatus === 'FULL_IMAGE' && this.imageData.length < 1) {
          this.showModalErr = true
          this.messErr = 'Bạn phải upload ít nhất một ảnh'
        }
        this.changeImage = true
      },

      async uploadImg() {
        try {
          this.arrayImgInsertSuccess = []
          for (let index = 0; index < this.arrayFormData.length; index++) {
            const element = this.arrayFormData[index]
            await CommonService.uploadImg(element).then(res => {
              if (res.code === 1000) {
                this.arrayImgInsertSuccess.push(res.data[0])
              }
            })
          }
          await this.saveImages()
        } catch (error) {
          console.log('add img reader', error)
        } finally {
          // this.$emit('successImg', 1)
        }
      },

      async saveImages() {
        try {
          this.transformImage()
          if (this.arrayImgInsertSuccess.length > 0) {
            this.arrayImgInsertSuccess.map(imgUrl => {
              this.generalImagesUpload.push({
                contractS3URL: imgUrl,
                accessKey: '',
                dataType: 'BILL',
              })
            })
            await this.updateImages()
          }
        } catch (error) {
          console.log('add img reader', error)
        } finally {
          // this.$emit('successImg', 1)
        }
      },

      async updateImages() {
        try {
          const body = {
            contractId: this.dataContract.id,
            customerId: this.dataContract.customerId,
            deviceType: 'WEB',
            images: this.generalImagesUpload,
            stores: this.dataContract.stores,
          }
          const response = await ContractService.saveMixFiles(body)
          if (response.result === true || response.success === true) {
            this.$emit('successImg', 1)
          } else {
            this.$emit('errorImg', response.message)
          }
        } catch (error) {
          console.log('add img reader', error)
        } finally {
          // this.$emit('successImg', 1)
        }
      },

      transformImage() {
        this.generalImagesUpload = this.generalImages.map(e => {
          return {
            accessKey: e.accessKey,
            dataType: e.dataType,
            contractS3URL: e.dataURL,
          }
        })
      },

      transformStoreImage() {
        this.dataContract.stores = this.dataContract.stores.map(e => {
          return {
            accessKey: e.accessKey,
            areaAddress: e.areaAddress,
            areaId: e.areaId,
            areaName: e.areaName,
            dataType: e.dataType,
            contractS3URL: e.dataURL,
          }
        })
      },
    },
  }
</script>

<style scoped>
  .modal-dialog {
    margin-top: 0;
  }
</style>
